/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How platform fee is applied to entry costs
 * @export
 */
export const CompetitionFeeStructure = {
    DEDUCTION: 'DEDUCTION',
    ADDON: 'ADDON'
} as const;
export type CompetitionFeeStructure = typeof CompetitionFeeStructure[keyof typeof CompetitionFeeStructure];


export function instanceOfCompetitionFeeStructure(value: any): boolean {
    for (const key in CompetitionFeeStructure) {
        if (Object.prototype.hasOwnProperty.call(CompetitionFeeStructure, key)) {
            if (CompetitionFeeStructure[key as keyof typeof CompetitionFeeStructure] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CompetitionFeeStructureFromJSON(json: any): CompetitionFeeStructure {
    return CompetitionFeeStructureFromJSONTyped(json, false);
}

export function CompetitionFeeStructureFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionFeeStructure {
    return json as CompetitionFeeStructure;
}

export function CompetitionFeeStructureToJSON(value?: CompetitionFeeStructure | null): any {
    return value as any;
}

export function CompetitionFeeStructureToJSONTyped(value: any, ignoreDiscriminator: boolean): CompetitionFeeStructure {
    return value as CompetitionFeeStructure;
}

